import { outter_post } from 'common/js/axios-helper';
import { ChannelCashApi } from "./constant/UrlMapper";

const host = '8880';
const host3 = '8883';



const getAllNames = (data) => {
    return outter_post(ChannelCashApi.GetAllNames, data, host);
};

const tatPayRateList = (data) => {
    return outter_post(ChannelCashApi.TatPayRateList, data, host);
};

const tatPayRateAdd = (data) => {
    return outter_post(ChannelCashApi.TatPayRateAdd, data, host);
};

const tatPayRateEdit = (data) => {
    return outter_post(ChannelCashApi.TatPayRateEdit, data, host);
};

const tatPayRateIsExist = (data) => {
    return outter_post(ChannelCashApi.TatPayRateIsExist, data, host);
};

const tatPayRateDel = (data) => {
    return outter_post(ChannelCashApi.TatPayRateDel, data, host);
};

const tatRefundList = (data) => {
    return outter_post(ChannelCashApi.TatRefundList, data, host3);
};

const getInfoByOrderId = (data) => {
    return outter_post(ChannelCashApi.GetInfoByOrderId, data, host3);
};

const tatRefundInfoList = (data) => {
    return outter_post(ChannelCashApi.TatRefundInfoList, data, host3);
};

const tatRefundInfoRefund = (data) => {
    return outter_post(ChannelCashApi.TatRefundInfoRefund, data, host3);
};

const tatRefundInfoForceRefund = (data) => {
    return outter_post(ChannelCashApi.TatRefundInfoForceRefund, data, host3);
};

const updatePaySt = (data) => {
    return outter_post(ChannelCashApi.UpdatePaySt, data, host3);
};


export default {
    getAllNames,
    tatPayRateList,
    tatPayRateAdd,
    tatPayRateEdit,
    tatPayRateDel,
    getInfoByOrderId,
    tatRefundList,
    tatRefundInfoList,
    tatRefundInfoRefund,
    tatRefundInfoForceRefund,
    updatePaySt,
    tatPayRateIsExist,
}



// WEBPACK FOOTER //
// ./src/service/ChannelCashService.js